import React from "react";

interface HeatmapTableProps {
  matrix: number[][];
  tooltipData: string[][];
  indexToColor: Map<number, string>;
  segmentBoundaries: Set<number>[];
  shortenedStopNames: string[];
  stopNames: string[];
  generalAmounts: number[];
  useMaxDensity: boolean;
}

export const HeatmapTable: React.FC<HeatmapTableProps> = ({
  matrix,
  tooltipData,
  indexToColor,
  segmentBoundaries,
  shortenedStopNames,
  stopNames,
  generalAmounts,
  useMaxDensity,
}) => {
  return (
    <div className="heatmap-wrapper">
      <div className="heatmap-table-container">
        <table className="heatmap-table">
          <thead>
            <tr>
              <th className="seat-header">
                {useMaxDensity ? "Вірт." : "Місце"}
              </th>
              <th className="stop-header-container-wrapper">
                <div className="stop-header-container">
                  {shortenedStopNames.map((name, idx) => (
                    <div
                      key={idx}
                      className="stop-header"
                      title={stopNames[idx]}
                    >
                      <span>{name}</span>
                    </div>
                  ))}
                </div>
              </th>
              <th className="sum-header">Сума</th>
            </tr>
          </thead>
          <tbody>
            {matrix.map((row, seatIdx) => (
              <tr key={seatIdx}>
                <td className="seat-number">{seatIdx + 1}</td>
                <td className="heatmap-cells-wrapper">
                  <div className="heatmap-cells-container">
                    {row.map((colorIndex, stopIdx) => (
                      <div
                        key={stopIdx}
                        className={`heatmap-cell ${
                          segmentBoundaries[seatIdx].has(stopIdx)
                            ? "segment-end"
                            : ""
                        }`}
                        style={{
                          backgroundColor:
                            indexToColor.get(colorIndex) || "#f1f3f4",
                        }}
                        title={tooltipData[seatIdx][stopIdx]}
                      />
                    ))}
                  </div>
                </td>
                <td className="sum-cell">
                  {generalAmounts[seatIdx].toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
